























import Vue from "vue";
import { WordSelectSentenceElement } from "@tt-app/types";

interface Computed {
  filledSentenceElements: any;
  sentenceElements: WordSelectSentenceElement[];
}

interface Props {
  complete: boolean;
  selections: any;
  structure: WordSelectSentenceElement[];
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  name: "WordSelectSentence",
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    selections: {
      type: Object,
      default: () => ({})
    },
    structure: {
      type: Array as () => WordSelectSentenceElement[],
      default: []
    }
  },
  computed: {
    filledSentenceElements() {
      const selections = JSON.parse(JSON.stringify(this.selections));

      const structure = this.sentenceElements.map(element => {
        let blankNumber = -1;
        if (element.type === "TEXT") {
          return element;
        } else if (element.type === "BLANK" && element.id) {
          blankNumber++;
          const selection = this.selections[element.id][blankNumber];

          const newElement = {
            ...element,
            ...selection,
            type: selection === undefined ? "BLANK" : "FILLED"
          };

          return newElement;
        } else {
          const selection = selections[0].shift();

          const newElement = {
            ...element,
            ...selection,
            type: selection === null ? "BLANK" : "FILLED"
          };

          return newElement;
        }
      });

      return structure;
    },

    sentenceElements() {
      return this.structure;
    }
  }
});
